import { Component, Inject } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { TranslateService } from '@services/translate/translate.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProfileService } from '@services/profiles/profile.service';

@Component({
    selector: 'app-add-new-profile',
    templateUrl: './add-new-profile.component.html',
    styleUrls: ['./add-new-profile.component.scss'],
    providers: [ProfileService],
    standalone: false
})
export class AddNewProfile {
  emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  profile: Models.Profile;
  emailInvalid;
  emailAlreadyExists;
  lastNameInvalid;
  firstNameInvalid

  constructor(
    private dialogRef: MatDialogRef<AddNewProfile>, @Inject(MAT_DIALOG_DATA) public data: any, private translate: TranslateService, private profileService: ProfileService
  ) {
    this.profile = new Models.Profile();
    this.translate.get('');
  }

  abort() {
    this.dialogRef.close();
  }

  async save() {
    this.emailInvalid = !this.emailRegex.test(this.profile.email);
    if (!this.emailInvalid) {
      this.emailAlreadyExists = !!(await this.profileService.find(0, 1, { email: this.profile.email })).data.length;
    } else {
      this.emailAlreadyExists = false;
    }
    this.firstNameInvalid = (this.profile.firstName?.length || 0) < 3;
    this.lastNameInvalid = (this.profile.lastName?.length || 0) < 3;
    if (!this.emailInvalid && !this.emailAlreadyExists && !this.lastNameInvalid && !this.firstNameInvalid) {
      this.dialogRef.close({ profile: this.profile });
    }
  }
}
